import React from 'react';
import { useTranslation } from 'react-i18next';
import PortalClients from '../Admin/PortalClients';

// Client-portal logins as a MODULE (owner 2026-08-29) — the same screen the Admin panel shows on
// its "Client Portal" tab, reachable at /m/portal_accounts by any employee who has been given the
// `portal_accounts` permission. One component, so the two entry points can never drift apart; the
// API behind it is gated by the same permission server-side (admins pass implicitly).
export default function PortalAccounts() {
  const { t } = useTranslation();
  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '16px 20px 10px' }}>
        <div style={{ fontSize: 18, fontWeight: 800, color: 'var(--text-primary)' }}>
          <i className="ti ti-id-badge" style={{ marginRight: 8 }} aria-hidden />{t('mod_portal_accounts')}
        </div>
      </div>
      <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', padding: '0 20px 20px' }}>
        <PortalClients />
      </div>
    </div>
  );
}
